import $ from "jquery";
import Splide from "@splidejs/splide";
$(function () {
	let quote_slider = document.querySelectorAll(".aka-quote-slider");

	if ($(".aka-block-quote-slider").hasClass('awards')) {
		var paginationSetting = false;
		var destroySplideSetting = true;
	} else {
		var paginationSetting = true;
		var destroySplideSetting = false;
	}

	if (quote_slider.length > 0) {
		for (let i = 0; i < quote_slider.length; i++) {
			let quote_sliderElement = quote_slider[i];
			let quote_sliderDefaultOptions = {
				type: "loop",
				arrows: false,
				autoplay: true,
				interval: 4000,
				pagination: paginationSetting,
				trimSpace: false,
				breakpoints: {
					768: {
						destroy: destroySplideSetting,
					},
				}
			};

			let quotes = new Splide(quote_sliderElement, quote_sliderDefaultOptions);
			quotes.mount();
		}
	}
});